import React, { FC, memo, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { AppRoutes } from 'app/config/routerConfig/types';
import { useSpecialPromotionModal } from 'features/SpecialPromotion';
import { Button } from 'shared/ui/Button';
import NewWarehouseSwissboxPromotionBanner from 'shared/assets/images/NewWarehouseSwissboxPromotionBanner.png';
import NewWarehouseSwissboxPromotionBannerMobile from 'shared/assets/images/NewWarehouseSwissboxPromotionBannerMobile.png';
import { Trans } from 'react-i18next';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';

export const NewWarehousePromotionContent: FC = () => {
  const { t } = useAppTranslation('booking');
  const { isDesktop } = useScreenBreakpoints();

  // const currencySymbol = useGetCurrencySymbol();
  const { closeModal } = useSpecialPromotionModal();

  const goToBooking = useCallback(() => {
    window.location.href = `${AppRoutes.BOOKING}?warehouseId=350f0943-ca4b-478d-941f-50c5b5c2472f`;
    closeModal();
  }, [closeModal]);

  return (
    <div>
      <img
        src={isDesktop ? NewWarehouseSwissboxPromotionBanner : NewWarehouseSwissboxPromotionBannerMobile}
        alt="New warehouse"
        className="min-h-[450px]"
      />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-w-[280px] desktop:max-w-[800px] w-full bg-white p-6 text-center shadow-xl rounded-xl">
        {/* <div className="mb-3 flex justify-end">
          <Button theme="clear" className="text-black" onClick={closeModal}>
            {t('Close')}
          </Button>
        </div> */}
        <div className="mb-2 desktop:mb-7 text-error font-bold text-2xl desktop:text-4xl uppercase">
          {t('NEW OPENING IN {{warehoseName}}!', { warehoseName: 'Dietikon' })}
        </div>
        <div className="font-normal desktop:text-2xl text-black desktop:px-4">
          <Trans
            t={t}
            i18nKey="From <0>{{dateFrom}}</0> we offer dry, secure storage units in various sizes."
            components={[<span key="0" className="font-bold desktop:text-2xl text-black" />]}
            values={{ dateFrom: '01.06.2026' }}
          />
        </div>
        <div className="desktop:text-2xl my-2 text-error font-bold underline">
          {t('Grand opening offer: 50% off for the first 3 months!')}
        </div>

        <Button fontSize={isDesktop ? 'large' : 'small'} onClick={goToBooking} className="!bg-accent mt-3" fontColor="text-white">
          {t('Rent now and secure your discount!')}
        </Button>
      </div>
    </div>
  );
};
